import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import AppSections from "../utils/AppSections";
import AnnotationsAddEdit from "../ui/annotations/AnnotationsAddEdit";
import Annotations from "../ui/annotations/Annotations";
import AnnotationDetails from "../ui/annotations/AnnotationDetails";

const AnnotationsRoutes = (
  <Route
    path={AppSections.ANNOTATIONS}
    element={
      <ProtectedRoute>
        <Annotations />
      </ProtectedRoute>
    }
  >
    <Route path=":id/view" element={<AnnotationDetails />} />
    <Route path=":id/edit" element={<AnnotationsAddEdit />} />
  </Route>
);

export default AnnotationsRoutes;
